import { render, staticRenderFns } from "./UbiquitousOverview.vue?vue&type=template&id=68b39978&scoped=true&"
import script from "./UbiquitousOverview.vue?vue&type=script&lang=js&"
export * from "./UbiquitousOverview.vue?vue&type=script&lang=js&"
import style0 from "./UbiquitousOverview.vue?vue&type=style&index=0&id=68b39978&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b39978",
  null
  
)

export default component.exports